// extracted by mini-css-extract-plugin
export default {"cardContainer":"EditNote_cardContainer__9yaVl","header":"EditNote_header__8deAP","body":"EditNote_body__+d43n","actions":"EditNote_actions__LrfHu"};